import { Translation } from "src/types"

// https://developer.mozilla.org/en-US/docs/Web/API/Navigator/languages
const translations: string[] = Object.values(Translation)

// return the sugarmate translation to use for this user
export function getLocaleMatch(): [Translation, string] {
  const languages = window.navigator.languages

  // iterate through user's preferred languages in order of preference
  for (const [
    index,
    languageTag,
  ] of languages.entries()) {
    const languageWithoutLocale = languageTag.split("-")[0]

    const exactMatch = translations.find(
      (translation) => translation.toLowerCase() === languageTag.toLowerCase(),
    )

    if (exactMatch) {
      return [
        exactMatch as Translation,
        languageTag,
      ]
    }

    let languageMatch = translations.find(
      (translation) => translation.toLowerCase() === languageWithoutLocale.toLowerCase(),
    )

    if (languageMatch) {
      // check if there is an exact region match for the same language lower in the preferences
      for (let i = index + 1; i < languages.length; i++) {
        const lowerPriorityTag = languages[i]
        const lowerPriorityLanguageWithoutLocale = lowerPriorityTag.split("-")[0]

        // stop check if the user prefers a different language
        if (lowerPriorityLanguageWithoutLocale !== languageWithoutLocale) {
          break
        }

        const lowerPriorityExactMatch = translations.find(
          (translation) => translation.toLowerCase() === lowerPriorityTag.toLowerCase(),
        )

        if (lowerPriorityExactMatch) {
          languageMatch = lowerPriorityExactMatch
          break
        }
      }

      return [
        languageMatch as Translation,
        languageTag,
      ]
    }
  }

  // fallback to english if no match is found
  return [
    Translation.English,
    "en",
  ]
}
